import { defineStore } from "pinia";

export const useMainNotifyStore = defineStore("MainNotifyStore", {
  state: () => ({
    isOpen: false,
  }),

  actions: {
    changeNotifyVisibility(value: boolean) {
      this.isOpen = value;
    },
  },
});
